import React, { useState, useEffect } from 'react';
import { Box, Typography, useMediaQuery } from '@material-ui/core';

import { down } from 'utils/breakpointHelpers';
import { pushMetricsEvent } from 'hooks/useDataLayer';
import { isFeatureEnabled } from 'utils/featureFlags';
import { HeaderContainer } from './styled';
import { ResultsHeaderProps } from './interface';
import { SortBy } from '../Filters/SortBy';
import { Search } from '../Filters/Search';
import FiltersButton from '../Filters/FiltersButton';

const ResultsHeader = ({
  total,
  control,
  openFilter,
  openFilters,
}: ResultsHeaderProps) => {
  const showMobileFiltersButton = useMediaQuery(down('lg'));
  const stackSearch = useMediaQuery(down('md'));
  const [searchEnabled, setSearchEnabled] = useState(false);

  useEffect(() => {
    // Only check feature flag on client-side to avoid hydration mismatch
    setSearchEnabled(isFeatureEnabled('productSearch'));
  }, []);

  return (
    <div>
      {searchEnabled && stackSearch && (
        <div style={{ marginBottom: '12px' }}>
          <Search control={control} />
        </div>
      )}
      <HeaderContainer className="justify-between lg:justify-start">
        <Box className="flex flex-row items-center gap-6 lg:flex-1">
          {!showMobileFiltersButton && !openFilters.desktop && (
            <FiltersButton
              show={() => {
                pushMetricsEvent('ga4', { event: 'filters_open' });
                openFilter((prev) => ({
                  mobile: false,
                  desktop: !prev.desktop,
                }));
              }}
            />
          )}
          <Typography variant="body2" className="font-brandon !font-medium">
            {total} Results
          </Typography>
        </Box>
        <Box className="mb-1 mt-2 flex justify-center lg:flex-1">
          {searchEnabled && !stackSearch && (
            <Box
              className="flex"
              style={{ width: showMobileFiltersButton ? '400px' : '500px' }}
            >
              <Search control={control} />
            </Box>
          )}
        </Box>

        <Box className="flex flex-row items-center justify-end gap-6 lg:flex-1">
          <SortBy control={control} />
          {showMobileFiltersButton ? (
            <FiltersButton
              show={() => openFilter({ mobile: true, desktop: false })}
            />
          ) : null}
        </Box>
      </HeaderContainer>
    </div>
  );
};

export default ResultsHeader;
